export default __webpack_public_path__ + "ba6fb03be5016b9a3e0dd651cbb5d790.png";